import { memo, ReactNode } from 'react'

import '@hotmart/cosmos/dist/input-group/input-group.css'

interface Props {
  children: ReactNode,
  prepend?: ReactNode,
  append?: ReactNode,
  className?: string
}

const InputGroup = ({ children, prepend, append, className }: Props) => (
  <hot-input-group class={className} data-test="input-group">
    {prepend && <div className="hot-input-group__prepend" data-test="prepend">{prepend}</div>}
    {children}
    {append && <div className="hot-input-group__append" data-test="append">{append}</div>}
  </hot-input-group>
)

export default memo(InputGroup)
